<template>
    <div v-if="local_page_keys !== null" data-app>
      <div class="uk-card uk-card-default uk-card-small uk-width-1-1 uk-animation-fade" style="min-height: calc(100vh - 40px);">
        <!--шапка страницы-->
        <div class="uk-card-header">
          <div data-uk-grid class="uk-grid uk-flex-middle">
            <div class="uk-width-expand">
              <h3 class="uk-card-title uk-margin-remove-top">
                {{ local_page_keys.title_admin_orders_history_page }} EDU <span v-if="showForClient !== ''">{{ local_page_keys.title_admin_orders_history_for_client }} {{ showForClient }}</span>
              </h3>
            </div>
            <div v-if="showForClient !== ''">
              <button class="uk-button uk-button-success tm-button-schedule-table"
                      @click="cancelClientSort()"
                      data-uk-tooltip="Сбросить фильтрацию">
                <md-icon>clear</md-icon>
              </button>
            </div>
          </div>
        </div>
        <!--контент-->
        <div class="uk-card-body">
          <div v-if="loading">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"></v-progress-circular>
          </div>
          <div v-else>
            <template v-if="errorHistoryList === null">
              <v-tabs :class="!tabHeadersDisplay ? ' tm-display-none ': ''"
                  v-model="tab"
                  background-color="primary"
                  dark>
                <v-tab
                    v-for="tabHeader of filteredTabHeaders"
                    :key="tabHeader.value"
                    @click=" fillingTab.includes(tabHeader.value) ? null: selectTab(tabHeader.value)"
                    :data-uk-tooltip="tabHeaderToolTip(tabHeader.value)">
                  {{ tabHeader.text }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                    v-for="group of tabHeaders"
                    :key="group.value"
                    class="tm-history-tab">
                  <v-card flat>
                    <v-card-text>
                      <AdminOrderHistoryTable
                          :showForClient="showForClient"
                          :tabs="tabHeaders"
                          :tab="tab"
                          :local_page_keys="local_page_keys"
                          :headers="headers[group.value]"
                          :ordersHistoryList= "ordersHistoryList[group.value] ? ordersHistoryList[group.value].orders : []"
                          @show_order_history="showOrderHistory($event)"
                          @sort_by_client="sortByClient($event)"
                          @show_info_broken="getBrokenInfo($event)"
                          @cancel_all_sort="cancelClientSort"
                          @openOrder="selectOrder">
                      </AdminOrderHistoryTable>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </template>
            <template v-else> {{ errorHistoryList }}</template>
          </div>
        </div>
      </div>

      <!--История заказа-->
      <md-dialog
          :md-active.sync="showDialog"
          :md-closed="true"
          :md-clicked-outside="true"
          :md-close-on-esc="true">
      </md-dialog>
      <!-- Для статуса broken_client-->
      <md-dialog
          :md-active.sync="showBrokenInfoDialog"
          :md-closed="true"
          :md-clicked-outside="true"
          :md-close-on-esc="true"
          class="222">
        <div class="uk-padding uk-position-relative tm-modal-page">
          <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeBrookenOrderInfoDialog">
            <span class="material-icons">close</span>
          </a>
          <div class="text-center">
            <md-dialog-title>
              {{ local_page_keys.order_broken_info_dialog_title }} <br> № {{ modal_broken_info.order_number }}
            </md-dialog-title>
          </div>

          <md-dialog-content>
            <div v-if="loadingBrokenInfo">
              <v-progress-circular
                  :width="2"
                  indeterminate
                  style="color: forestgreen"></v-progress-circular>
            </div>
            <div v-else class="uk-margin">
              <template v-if="Object.keys(modal_broken_info).includes('error')">
                <p>{{ modal_broken_info.error }}</p>
              </template>
              <template v-else>
                <md-table>
                  <md-table-row>
                    <md-table-head v-for="header of headersInfoBrokenOrderTable" :key="header.id" :label="header.text">
                      {{ header.text }}
                    </md-table-head>
                  </md-table-row>
                  <md-table-row v-for="section in Object.keys(modal_broken_info.info)" :key="section.id">
                    <md-table-cell v-for="header of headersInfoBrokenOrderTable" :key="header.id">
                      <template v-if="header.value === 'key'">
                        {{ local_page_keys['broken_order_info_section_' + section] }}
                      </template>
                      <div v-else style="text-align: start;">
                        <template v-if="section === 'finances'">
                          <p v-if=" typeof (modal_broken_info.info[section]) === 'string'">{{ modal_broken_info.info[section] }}</p>
                          <md-list v-else>
                            <md-list-item v-for="item of Object.keys(modal_broken_info.info[section])" :key="item.id">
                              {{ item }} - {{ brokenOrderFinancesInfoFilter(modal_broken_info.info[section][item]) }}
                            </md-list-item>
                          </md-list>
                        </template>
                        <template v-else-if="section === 'order_functions'">
                          <template v-if="modal_broken_info.info[section] !== 'No info about order functions'">
                            <md-list>
                              <md-list-item v-for="item of Object.keys(modal_broken_info.info[section])" :key="item.id">
                                <template v-if="modal_broken_info.info[section][item].length !== 0">
                                  {{ item == 0 ? 'Total order' : 'Face ' + item }}:
                                  <md-list-item>
                                    <md-list-item v-for="func of Object.keys(modal_broken_info.info[section][item])" :key="func.id">
                                      {{ func }}: <pre style="padding-left: 10%;">{{ modal_broken_info.info[section][item][func] }}</pre>
                                    </md-list-item>
                                  </md-list-item>
                                </template>
                              </md-list-item>
                            </md-list>
                          </template>
                          <template v-else>
                            {{ modal_broken_info.info[section] }}
                          </template>
                        </template>
                        <template v-else-if="section === 'photo_info'">
                          <md-list>
                            <md-list-item v-for="key of Object.keys(modal_broken_info.info[section])" :key="key.id">
                              <p v-if="modal_broken_info.info[section][key] === null">
                                {{ key }} - <span class="text-danger">{{ local_page_keys.broken_order_info_table_broken_photo_before }}</span>
                              </p>
                              <p v-else>
                                <a :href="photoBeforeUrl + modal_broken_info.info[section][key]" target="_blank">{{ key }}</a>
                              </p>
                            </md-list-item>
                          </md-list>
                        </template>
                        <template v-else-if="section === 'created_request_info'">
                          <template v-if="modal_broken_info.info[section] !== 'Failed info'">
                            <pre>{{ modal_broken_info.info[section] }}</pre>
                          </template>
                          <template v-else>
                            {{ modal_broken_info.info[section] }}
                          </template>
                        </template>
                      </div>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </template>
            </div>
          </md-dialog-content>
        </div>
      </md-dialog>
      <!--Просмотр заказа-->
      <md-dialog
          :md-active.sync="showDialogOrder"
          :md-closed="true"
          :md-clicked-outside="true"
          :md-close-on-esc="true"
          class="tm-dialog-progress-report tm-dialog-admin-order-history">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialogOrder = false">
          <span class="material-icons">close</span>
        </a>
        <div>
          <div class="uk-grid uk-flex-middle" data-uk-grid>
            <div class="uk-width-1-2">
              <v-tabs v-model="tabInfo">
                <v-tab class="uk-background-muted">
                  {{ local_page_keys.tab_title_history_order}}
                </v-tab>
                <v-tab class="uk-background-muted">
                  {{ local_page_keys.tab_title_info_order}}
                </v-tab>
              </v-tabs>
            </div>
            <div class="uk-width-1-2 uk-text-center">
              <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
                <div>
                  <a href="#"
                     :disabled="activeOrderKey <= 0"
                     class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                     role="button"
                     data-uk-tooltip="title: Предыдущий заказ"
                     @click="prevOrder">
                    <span class="material-icons">chevron_left</span>
                  </a>
                </div>
                <div>
                  <a href="#"
                     :disabled="activeOrderKey >= (activeOrders.length-1)"
                     class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                     role="button"
                     data-uk-tooltip="title: Следующий заказ"
                     @click="nextOrder">
                    <span class="material-icons">chevron_right</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-tabs-items v-model="tabInfo">
          <v-tab-item style="min-height: 600px; max-height: 80vh; overflow-y: auto;">
            <v-card flat>
              <v-card-text>
                <div v-if="loadingOrderView">
                  <v-progress-circular
                      :width="2"
                      indeterminate
                      style="color: forestgreen"></v-progress-circular>
                </div>
                <div class="uk-position-relative tm-modal-page">
                  <div class="uk-grid uk-flex-middle" data-uk-grid>
                    <div class="uk-width-auto">
                      <h4>{{ this.local_page_keys_report.order_number }}: {{ currendOrderId }}</h4>
                    </div>
                  </div>
                  <div class="uk-margin" v-if="!activeOrderReload">
                    <OrderView></OrderView>
                  </div>
                  <hr class="uk-margin-medium">
                  <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
                  <prev-orders-block-for-admin :currentOrderId="currendOrderId"></prev-orders-block-for-admin>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item style="min-height: 600px; max-height: 80vh; overflow-y: auto;">
            <v-card flat>
              <v-card-text>
                <div class="uk-padding uk-position-relative tm-modal-page">
                  <div class="text-center">
                    <md-dialog-title>
                      {{ local_page_keys.order_history_info_dialog_title }}№ {{ modal_info.order_number }}
                    </md-dialog-title>
                  </div>
                  <md-dialog-content>
                    <div v-if="loadingOrderHistoryInfo">
                      <v-progress-circular
                          :width="2"
                          indeterminate
                          style="color: forestgreen"></v-progress-circular>
                    </div>
                    <div v-if="Object.keys(modal_info).includes('info_table')" class="uk-margin">
                      <md-table>
                        <md-table-row>
                          <md-table-head v-for="header of headersInfoTable" :key="header.id" :label="header.text">
                            {{ header.text }}
                          </md-table-head>
                        </md-table-row>
                        <md-table-row>
                          <md-table-cell v-for="header of headersInfoTable" :key="header.id">
                            <template v-if="(header.value === 'last_retoucher' || header.value === 'last_pro_retoucher')">
                              {{ modal_info.info_table[header.value] === '' ? modal_info.info_table[header.value] : modal_info.info_table[header.value].name }}
                            </template>
                            <template v-else>
                              {{ modal_info.info_table[header.value] }}
                            </template>
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                    <div v-if="Object.keys(modal_info).includes('particular_table')" class="uk-margin">
                      <div class="text-center" v-if="!showParticularInfoTable">
                        <button class="btn btn-outline-primary" @click="showParticularInfoTable = !showParticularInfoTable">
                          {{ local_page_keys.modal_button_show_particular_table }}
                        </button>
                      </div>
                      <div v-else>
                        <div class="text-center">
                          <button class="btn btn-outline-dark" @click="showParticularInfoTable = !showParticularInfoTable">
                            {{ local_page_keys.modal_button_hide_particular_table }}
                          </button>
                        </div>
                        <md-table>
                          <md-table-row>
                            <md-table-head v-for="header of headersParticularInfoTable" :key="header.id" :label="header.text">
                              {{ header.text }}
                            </md-table-head>
                          </md-table-row>
                          <md-table-row v-for="item of sortByDate(modal_info.particular_table)" :key="item.id">
                            <md-table-cell v-for="header of headersParticularInfoTable" :key="header.id">
                              {{ item[header.value] }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </md-dialog-content>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </md-dialog>
    </div>

</template>

<script>

import filter_table_admin_orders_history from "../../../filters/filter_table_admin_orders_history";
import AdminOrderHistoryTable from "../Components/AdminOrderHistoryTable.vue";
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";

export default {
  name: "ProRetoucherOrderEducationHistory",
  filters: {filter_table_admin_orders_history},
  components: {
    AdminOrderHistoryTable,
    OrderView,
    PrevOrdersBlockForAdmin,
  },
  data: () => ({
    showBrokenInfoDialog: false,
    showDialog: false,
    showDialogOrder: false,
    activeOrderReload: false,
    currendOrderId:null,
    local_page_keys: null,
    local_page_keys_report:null,
    headers: [],
    headersInfoTable: [],
    headersInfoBrokenOrderTable: [],
    headersParticularInfoTable: [],
    tab: null,
    tabInfo: null,
    modal_info: {},
    modal_broken_info: {},
    ordersHistoryList: {},
    errorHistoryList: null,
    showForClient: '',
    loading: true,
    loadingBrokenInfo: true,
    loadingOrderHistoryInfo: true,
    loadingOrderView:true,
    showParticularInfoTable: false,
    activeOrders: [],
    activeOrderKey: null,
    tabHeaders:[],
    tabHeadersDisplay: false,
    fillingTab:[],
    choosenDefaultPeriod: []
  }),
  methods: {
    getTabHeaders() {
      this.tabHeaders = [
        { text:this.local_page_keys.tab_title_ordersEducation, value:'ordersEducation' },
        // { text:this.local_page_keys.tab_title_ordersAll, value:'ordersAll' },
        // { text:this.local_page_keys.tab_title_ordersDone, value:'ordersDone' },
        // { text:this.local_page_keys.tab_title_ordersInWork, value:'ordersInWork' },
        // { text:this.local_page_keys.tab_title_rejectByAdmin, value:'rejectByAdmin' },
        // { text:this.local_page_keys.tab_title_rejectByRetoucher, value:'rejectByRetoucher' },
        // { text:this.local_page_keys.tab_title_firstAndSecond, value:'firstAndSecond' },
        // { text:this.local_page_keys.tab_title_ordersDoneSenior, value:'ordersDoneSenior' },
        // { text:this.local_page_keys.tab_title_ordersForcedClosed, value:'ordersForcedClosed' },
        // { text:this.local_page_keys.tab_title_returnRetouchers, value:'returnRetouchers' }
      ]
    },
    getHeaders() {
      this.headers = {
        ordersEducation: [
          {text: this.local_page_keys.table_header_order_number, value: 'order_number'},
          {text: this.local_page_keys.table_header_order_id, value: 'order_id'},
          {text: this.local_page_keys.table_header_id_client, value: 'ID_client'},
          {text: this.local_page_keys.table_header_order_status, value: 'status'},
          {text: this.local_page_keys.table_header_check_senior, value: 'check_senior'},
          {text: this.local_page_keys.table_header_process_retoucher, value: 'process-retoucher'},
          {text: this.local_page_keys.table_header_created_at, value: 'created_at'},
          {text: this.local_page_keys.table_header_updated_at, value: 'updated_at'},
          {text: this.local_page_keys.table_header_order_finances, value: 'finances'},
        ],
        ordersAll: [
          {text: this.local_page_keys.table_header_order_number, value: 'order_number'},
          {text: this.local_page_keys.table_header_order_id, value: 'order_id'},
          {text: this.local_page_keys.table_header_id_client, value: 'ID_client'},
          {text: this.local_page_keys.table_header_order_status, value: 'status'},
          {text: this.local_page_keys.table_header_check_senior, value: 'check_senior'},
          {text: this.local_page_keys.table_header_process_retoucher, value: 'process-retoucher'},
          {text: this.local_page_keys.table_header_created_at, value: 'created_at'},
          {text: this.local_page_keys.table_header_updated_at, value: 'updated_at'},
          {text: this.local_page_keys.table_header_order_finances, value: 'finances'},
        ],

        ordersInWork: [
          {text: this.local_page_keys.table_header_order_number, value: 'order_number'},
          {text: this.local_page_keys.table_header_order_id, value: 'order_id'},
          {text: this.local_page_keys.table_header_id_client, value: 'ID_client'},
          {text: this.local_page_keys.table_header_order_status, value: 'status'},
          {text: this.local_page_keys.table_header_user_now, value: 'user_now'},
          {text: this.local_page_keys.table_header_check_senior, value: 'check_senior'},
          {text: this.local_page_keys.table_header_minutes_from_create, value: 'minutes_from_create'},
          {text: this.local_page_keys.table_header_min_spent_on_order, value: 'min_spent_on_order'},
          {text: this.local_page_keys.table_header_order_created_time, value: 'order_created_time'},
          {text: this.local_page_keys.table_header_latest_activity, value: 'latest_activity'},
          {text: this.local_page_keys.table_header_last_customer_activity, value: 'last_customer_activity'},
          {text: this.local_page_keys.table_header_show_orders_count, value: 'show_orders_count'},
          {text: this.local_page_keys.table_header_period_by_date, value: 'period_by_date'},
        ],
      };
      this.headers.ordersDone = this.headers.ordersInWork;
      this.headers.ordersDoneSenior = this.headers.ordersInWork;
      this.headers.ordersForcedClosed = this.headers.ordersInWork;

      this.headers.rejectByAdmin = this.headers.ordersInWork;
      this.headers.rejectByRetoucher = this.headers.ordersInWork.concat([{text: this.local_page_keys.table_header_rejected_retoucher_count, value: 'table_header_rejected_retoucher_count'}]);
      this.headers.firstAndSecond = this.headers.ordersInWork.concat([{text: this.local_page_keys.table_header_added_functions, value: 'table_header_added_functions'}]);
      this.headers.returnRetouchers = this.headers.ordersInWork.concat([{text: this.local_page_keys.table_header_rejected_max_rejects, value: 'table_header_rejected_max_rejects'},{text: this.local_page_keys.table_header_rejected_total_rejects, value: 'table_header_rejected_total_rejects'}]);

      this.headersInfoTable = [
        {text: this.local_page_keys.modal_info_table_header_order_id, value: 'order_id'},
        {text: this.local_page_keys.modal_info_table_header_order_number, value: 'order_number'},
        {text: this.local_page_keys.modal_info_table_header_last_retoucher, value: 'last_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_last_pro_retoucher, value: 'last_pro_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_created_at, value: 'created_at'},
        {text: this.local_page_keys.modal_info_table_header_updated_at, value: 'updated_at'},

      ];
      this.headersParticularInfoTable = [
        {text: this.local_page_keys.modal_particular_info_table_header_order_date, value: 'date'},
        {text: this.local_page_keys.modal_particular_info_table_header_order_new_status, value: 'new_status'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_role, value: 'user_role'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_email, value: 'user_email'},

      ];
      this.headersInfoBrokenOrderTable = [
        {text: this.local_page_keys.modal_info_broken_order_table_header_order_key, value: 'key'},
        {text: this.local_page_keys.modal_info_broken_order_table_header_order_value, value: 'value'},

      ];

    },
    async getOrdersHistoryList(page, per_page, tab = null) {
      this.loading = true;
      let defaultPeriod =  {
        date_start: this.choosenDefaultPeriod[0],
        date_end: this.choosenDefaultPeriod[1],
      };
      await this.$store.dispatch('adminOrdersHistory/adminOrdersHistoryList', {page, per_page, tab, defaultPeriod});
      let data = await this.$store.getters['adminOrdersHistory/adminOrdersHistoryList'];
      this.fillingTab.push(tab);

      if (typeof data === 'object' && data.status === "success") {
        this.ordersHistoryList[tab] = data.data;
        this.loading = false;
      } else {
        alert(this.local_page_keys.alert_something_went_wrong);
        this.errorHistoryList = this.local_page_keys.alert_something_went_wrong;
        this.loading = false;
      }
    },
    tabHeaderToolTip(value) {
      const tooltips =
          {
            'ordersEducation': "",
            'ordersAll': "",
            'ordersDone': "Заказы по дням в статусе done-admin с расчетом скорости выполнения заказов в минутах",
            'ordersInWork': "Незавершенные заказы в статусе выполнения и расчетом продолжительности выполнения",
            'rejectByAdmin': "Заказы по дням, которые админ отказал в выполнении заказчику",
            'rejectByRetoucher': "Заказы по дням, в которых было 1+ отказов от выполнения ретушером, не зависимо от причины",
            'firstAndSecond': "Заказы по дням, которые прошли через статус hold-admin-new и проверяющий имел возможность/добавил дополнительные функции на сое усмотрение",
            'ordersDoneSenior':'Отображаются заказы проверенные senior-retoucher по дням',
            'ordersForcedClosed':'Отображаются заказы принудительно завершенные проверяющим (нажата белая кнопка) с целью прекращения правок от клиента',
            'returnRetouchers':'Отображаются заказы, которые были возвращены на переделку ретушеру более 1-го раза',
          };
      return tooltips[value];
    },
    async selectTab(tab) {
      await this.getOrdersHistoryList(1, 10, tab);
    },
    async sortByClient(client_id) {
      if (confirm(this.local_page_keys.confirm_show_orders_for_client)) {
        let params =  { page: 1, per_page: 10, client_id, tab: this.tab}
        this.loading = true;
        await this.$store.dispatch('adminOrdersHistory/adminOrdersHistoryByClientId', params);
        let data = await this.$store.getters['adminOrdersHistory/adminOrdersHistoryByClientId'];
        if (typeof data === 'object' && data.status === "success") {
          this.ordersHistoryList = [];
          this.showForClient = client_id;
          this.ordersHistoryList['ordersAll'] = data.data;
          this.loading = false;
        } else {
          alert(this.local_page_keys.alert_something_went_wrong);
          this.loading = false;
        }
      }
    },
    getTabTranslate(tab) {
      let local_key = 'tab_title_' + tab;
      return this.local_page_keys[local_key];
    },
    async showOrderHistory(order_id) {
      this.loadingOrderHistoryInfo = true;
      await this.$store.dispatch('adminOrdersHistory/orderHistoryInfo', {order_id});
      let data = await this.$store.getters['adminOrdersHistory/orderHistoryInfo'];
      if (typeof data === 'object') {
        if (Object.keys(data).includes('info_table')) {
          this.modal_info['info_table'] = data.info_table;
        }
        if (Object.keys(data).includes('particular_table') && data.particular_table.length > 0) {
          this.modal_info['particular_table'] = data.particular_table;
        }
        this.modal_info['order_number'] = this.modal_info.info_table['order_number'];
        this.loadingOrderHistoryInfo = false;
      } else {
        this.loadingOrderHistoryInfo = false;
        this.modal_info['error'] =  data;
      }
    },
    async getBrokenInfo(order) {
      this.loadingBrokenInfo = true;
      this.modal_broken_info['order_number'] = order.order_number;
      this.modal_broken_info['info'] = [];
      this.showBrokenInfoDialog = true;
      await this.$store.dispatch('adminOrdersHistory/brokenOrderInfo', order.order_id);
      let data = await this.$store.getters['adminOrdersHistory/brokenOrderInfo'];
      if (typeof data === 'object' && data.status === 'success') {
        this.modal_broken_info['info'] = data.result;
      } else {
        this.modal_broken_info['error'] = data;
      }
      this.loadingBrokenInfo = false;
    },
    async cancelClientSort(currentTab) {
      this.showForClient = '';
      await this.getOrdersHistoryList(1, 10, 'ordersAll');
    },
    brokenOrderFinancesInfoFilter(data) {
      return data !== '' ? Number (data).toFixed(2) : '??';
    },
    sortByDate(array) {
      let sortedArray = array.sort(function (a, b) {
        let firstDate = new Date(a.date);
        let secondDate = new Date(b.date);
        return firstDate - secondDate;
      })
      return sortedArray;
    },
    closeBrookenOrderInfoDialog() {
      this.showBrokenInfoDialog = false;
      this.loadingBrokenInfo = true;
      this.modal_broken_info = {};
    },
    closeOrderInfoDialog() {
      this.showDialog = false;
      this.loadingOrderHistoryInfo = true;
      this.showParticularInfoTable = false;
      this.modal_info = {};

    },
    async selectOrder({orderId, currentTab, tabList}) {
      if (tabList) {
        this.activeOrders = tabList.map((order) => {
          return order.order_id ?? null;
        });
      }
      this.activeOrderKey = this.activeOrders.indexOf(orderId);
      await this.openOrder(orderId);
    },
    async openOrder(order_id) {
      this.activeOrderReload = true;
      this.loadingOrderView = true;
      await this.$store.dispatch('order/setViewOrderId', order_id);
      this.currendOrderId = order_id;
      this.showDialogOrder = true;
      this.activeOrderReload = false;
      this.loadingOrderView = false;
      this.showOrderHistory(order_id)
      location.hash = order_id;
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey + 1]);
        this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey - 1]);
        this.activeOrderKey--;
      }
    },
    getDefaultPeriod() {
        let currentDate = new Date();
        let formattedDateEnd = currentDate.getFullYear() + '-' + ((currentDate.getMonth() + 1) < 10 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
        let dateToWeek = new Date(); // Создаем новый объект Date для начальной даты
        dateToWeek.setDate(currentDate.getDate() - 7); // Устанавливаем начальную дату на неделю назад
        let formattedDateStart = dateToWeek.getFullYear() + '-' + ((dateToWeek.getMonth() + 1) < 10 ? '0' : '') + (dateToWeek.getMonth() + 1) + '-' + (dateToWeek.getDate() < 10 ? '0' : '') + dateToWeek.getDate();
        this.choosenDefaultPeriod.push(formattedDateStart, formattedDateEnd );
    }
  },
  computed: {
    photoBeforeUrl() {
      return process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    },
    filteredTabHeaders() {
      if (this.showForClient) {
        return this.tabHeaders.filter(item => item.value === 'ordersAll');
      } else {
        return this.tabHeaders;
      }
    },

  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('admin_orders_history');
    await this.getOrdersHistoryList(1, 10,'ordersEducation');
    this.getHeaders();
    this.getTabHeaders();

  },
  async created() {
    this.getDefaultPeriod();
    this.local_page_keys_report = await this.$filtergetLocalisationPage('pro_retoucher_progress_report');
  }
}
</script>

<style>
@import '../../../assets/css/uikit/list.css';
.tm-history-grid-head,
.tm-history-grid {
  line-height: 1.2;
}
.tm-display-none{
  display: none !important;
}
</style>